export const SESSION_VERSION_COOKIE = "session_ver";

// Bump this env var (NUXT_PUBLIC_REQUIRED_SESSION_VERSION) to force a one-time logout.
// Keeping a central constant for the cookie name prevents drift.

// Session validation configuration
// Sessions expire after 30 minutes of inactivity
export const SESSION_VALIDATION_EXPIRY_MS = 30 * 60 * 1000;
export const SESSION_VALIDATED_AT_KEY = "sessionValidatedAt";

/**
 * Check if the current session has exceeded the validation expiry time
 * @returns true if session is stale (needs revalidation), false otherwise
 */
export const isSessionStale = (): boolean => {
  if (typeof window === "undefined") {
    return true; // Server-side always requires validation
  }

  const lastValidated = localStorage.getItem(SESSION_VALIDATED_AT_KEY);
  if (!lastValidated) {
    return true;
  }

  const timeSinceValidation = Date.now() - parseInt(lastValidated, 10);
  return timeSinceValidation > SESSION_VALIDATION_EXPIRY_MS;
};
